import { Box } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import Logo from '../Logo';
import GlobalSearch from './components/GlobalSearch';
import UserMenu from './components/UserMenu';
import UserNotifications from './components/UserNotifications';

export default function Header() {
  return (
    <AppBar
      position="fixed"
      color="inherit"
      sx={(theme) => ({
        zIndex: theme.zIndex.drawer + 1,
      })}
    >
      <Toolbar disableGutters>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', px: 3, py: 1 }}>
          <Logo />
          <GlobalSearch />
          <Box>
            <UserNotifications />
            <UserMenu />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
